import { render, staticRenderFns } from "./VGoalHeadline.vue?vue&type=template&id=62ef97eb&"
import script from "./VGoalHeadline.vue?vue&type=script&lang=js&"
export * from "./VGoalHeadline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports